import { render, staticRenderFns } from "./ListTeamsBan.vue?vue&type=template&id=012d9470"
import script from "./ListTeamsBan.vue?vue&type=script&lang=js"
export * from "./ListTeamsBan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports